var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "list-root" }, [
    _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "edit-column" }, [
        _c("div", [
          _vm._v(_vm._s(_vm.$t("manuscriptPage.manuscriptFolderList.folder"))),
        ]),
        _vm.isInsert
          ? _c(
              "div",
              { staticClass: "sorting", on: { click: _vm.completeSetFolder } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "manuscriptPage.manuscriptFolderList.moveManuscript"
                      )
                    ) +
                    " "
                ),
              ]
            )
          : _c(
              "div",
              {
                staticClass: "sorting",
                on: {
                  click: function ($event) {
                    return _vm.switchEditMode()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isEditMode
                        ? _vm.$t("common.save")
                        : _vm.$t("manuscriptPage.manuscriptFolderList.sort")
                    ) +
                    " "
                ),
              ]
            ),
      ]),
    ]),
    _vm.items
      ? _c(
          "div",
          { staticClass: "list" },
          [
            !_vm.isInsert && !_vm.isEditMode
              ? _c("list-folder-item", {
                  attrs: {
                    label: _vm.$t(
                      "manuscriptPage.manuscriptFolderList.allManuscripts"
                    ),
                    count: _vm.manuscriptsCount,
                    onSelectCallback: () => _vm.selectFolder(""),
                    disabledMenu: true,
                  },
                })
              : _vm._e(),
            _vm.isInsert
              ? _c("div", { staticClass: "folder-select-description" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "manuscriptPage.manuscriptFolderList.selectFolderDescription"
                        )
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c("sortable-list", {
              staticClass: "list-container",
              attrs: {
                items: _vm.folders,
                keyAttr: "manuscriptFolderId",
                disabled: !_vm.isEditMode,
                extra: _vm.isEditMode,
              },
              on: {
                "update:items": function ($event) {
                  _vm.folders = $event
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ item, extra }) {
                      return [
                        _c("list-folder-item", {
                          attrs: {
                            label: item.name,
                            count: item.manuscriptKeys.length,
                            isSorting: extra,
                            isSelecting: _vm.isInsert,
                            onSelectCallback: () =>
                              _vm.selectFolder(item.manuscriptFolderId),
                            isChecked: _vm.isSelectedFolder(
                              item.manuscriptFolderId
                            ),
                            onCheckCallback: () =>
                              _vm.onToggleInsertFolder(item.manuscriptFolderId),
                            onRenameCallback: () =>
                              _vm.renameManuscriptFolder(
                                item.manuscriptFolderId
                              ),
                            onDeleteCallback: () =>
                              _vm.deleteManuscriptFolder(
                                item.manuscriptFolderId
                              ),
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                false,
                3941407085
              ),
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isEditMode && !_vm.isInsert,
            expression: "!isEditMode && !isInsert",
          },
        ],
        staticClass: "create",
        on: { click: _vm.createManuscriptFolder },
      },
      [
        _vm._v(
          " " +
            _vm._s(_vm.$t("manuscriptPage.manuscriptFolderList.newCreate")) +
            " "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }